import React from 'react';

class FlashBox extends React.Component {
  render(){
    const { message } = this.props;
    if(message){
      return (
        <div className='success'>{message}</div>
      )
    }
    return null;
  }
}
export default FlashBox;
